import { render, staticRenderFns } from "./LIM.vue?vue&type=template&id=4d9591e0&scoped=true"
import script from "./LIM.vue?vue&type=script&lang=js"
export * from "./LIM.vue?vue&type=script&lang=js"
import style0 from "./LIM.vue?vue&type=style&index=0&id=4d9591e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9591e0",
  null
  
)

export default component.exports